export function getQueryParams(url, parameter) {
  const params = new URLSearchParams(url)
  return params.get(parameter)
}

export function getSiteFromHostname(hostname = window.location.hostname) {
  const normalizedHostname = hostname.toLowerCase()

  if (normalizedHostname.includes('louvrehotels')) {
    return 'lhg'
  }

  return 'row'
}
